import React, { useEffect, useState } from 'react';
import {
  Redirect,
} from 'react-router-dom';
import LogRocket from 'logrocket';
import Text from '../../components/Text';
import { extractInviteFromURL } from '../../utils/urlHelpers';
import { getReferenceFromInvite } from '../../services/loanRetrievalService';
import SITE_PATHS from '../../config/sitePaths';
import Agreement from '../Agreement';

const getInviteId = (guestUserInfo, pathname) => {
  const inviteIdFromURL = extractInviteFromURL(pathname).inviteId;
  if (!inviteIdFromURL && guestUserInfo) {
    return guestUserInfo.inviteId;
  }
  return inviteIdFromURL;
};

export default function Invite(props) {
  const {
    onAgreementAccepted,
  } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [inviteResponse, setInviteResponse] = useState(null);
  const [agreementAccepted, setAgreementAccepted] = useState(false);

  const handleAgreementAccepted = (guestUserData) => {
    onAgreementAccepted(guestUserData);
    setAgreementAccepted(true);
  };

  const {
    guestUserInfo,
    location: {
      state: {
        requestId,
        ref,
      } = {},
    } = {},
  } = props;
  const inviteId = getInviteId(
    guestUserInfo,
    props.location?.pathname || window.location.pathname,
  );

  useEffect(() => {
    const initialize = async () => {
      try {
        const result = await getReferenceFromInvite(
          inviteId,
          requestId,
          ref,
        );
        setInviteResponse(result);
      } finally {
        setIsLoading(false);
      }
    };
    initialize();
  }, [inviteId, requestId, ref]);

  if (isLoading) return null;

  if (!inviteResponse?.clientId || !inviteResponse.requestId) {
    return (
      <div className="font-weight-bold mt-4">
        <Text value="Invite link is invalid or expired, please contact your lending provider." />
      </div>
    );
  }
  LogRocket.identify(inviteResponse.requestId, { client: inviteResponse.clientId });

  const state = {
    requestId,
    ref,
    ...inviteResponse,
    autoConfirmLoan: true,
  };

  if (inviteResponse?.bankingConfig?.skipAgreement || agreementAccepted) {
    return (
      <Redirect
        from={SITE_PATHS.INVITE_PAGE}
        to={{ pathname: SITE_PATHS.LOAN, state }}
      />
    );
  }
  return (
    <Agreement
      history={props.history}
      onAgreementAccepted={handleAgreementAccepted}
      isGuestUser
    />
  );
}
